import React from 'react'

const ReviewedCheck = () => {
  return (
    <svg
      css={`
        display: inline-block;
      `}
      width="14"
      height="16"
      viewBox="0 0 14 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.165 1.01399L7.165 0.0139894C7.05574 -0.00401209 6.94426 -0.00401209 6.835 0.0139894L0.835 1.01399C0.601682 1.05302 0.389756 1.1735 0.236878 1.35403C0.0839997 1.53455 6.9448e-05 1.76343 0 1.99999V8.99999C0 14 7 16 7 16C7 16 14 14 14 8.99999V1.99999C13.9999 1.76343 13.916 1.53455 13.7631 1.35403C13.6102 1.1735 13.3983 1.05302 13.165 1.01399V1.01399ZM6.065 11.481L2.293 7.70699L3.707 6.29299L5.933 8.51899L10.233 3.35899L11.769 4.64099L6.065 11.481Z"
        fill="#31279B"
      />
    </svg>
  )
}

export default ReviewedCheck
